module.exports = __webpack_public_path__ + "img/aksiyon_logo_buyuk_mavi.012a4089.png";